import styled from 'styled-components'
// @ts-ignore
import { Card, Modal, ModalHeader } from 'reactstrap'
// @ts-ignore
import { Button } from 'dsm-react-lib'
const getBackgroundColor = (theme: string): string => {
  switch (theme) {
    case 'secondary':
      return 'var(--color-secondary)'
    case 'info':
      return 'var(--color-info)'
    default:
      return 'var(--color-primary)'
  }
}

export const Wrapper = styled.div<{ isOpen: boolean }>`
  height: -webkit-fill-available;
  display: ${(props) => (props.isOpen ? '' : 'none')};
`

export const StyledHeader = styled(ModalHeader)<{ theme: string }>`
  justify-content: space-between;
  background-color: ${(props) => getBackgroundColor(props.theme)} !important;
`

export const StyledTitle = styled.h5`
  color: var(--surface-bg) !important;
`

export const StyledFrame = styled.iframe`
  width: 100%;
  margin-top: 0;
  padding: 0 1rem;
  @media only screen and (min-width: 2561px) {
    height: 800px;
  }
  @media only screen and (min-width: 1601px) and (max-width: 2560px) {
    height: 350px;
  }
  @media only screen and (min-width: 1024px) and (max-width: 1600px) {
    height: 200px;
  }
`

export const StyledCard = styled(Card)`
  padding: 0 1rem 1rem 1rem;
  margin-top: 1rem;
  max-height: 500px;
  @media only screen and (min-width: 1601px) and (max-width: 2560px) {
    max-height: 180px;
    overflow: auto;
  }
  @media only screen and (min-width: 1024px) and (max-width: 1600px) {
    max-height: 150px;
    overflow: auto;
  }
  ::-webkit-scrollbar {
    width: 15px !important;
  }
  ::-webkit-scrollbar-track {
    background: var(--surface-bg);
  }
`

export const StyledModal = styled(Modal)`
  max-width: 900px;
  @media only screen and (min-width: 2561px) {
    max-width: 1600px;
  }
  @media only screen and (min-width: 1601px) and (max-width: 2560px) {
    max-width: 1100px;
  }
`

export const AttestationTitle = styled.span<{ $isItalic?: boolean }>`
  font-style: ${(props) => (props.$isItalic ? 'italic' : 'normal')};
  @media only screen and (min-width: 1024px) and (max-width: 1600px) {
    font-size: 12px;
  }
`

export const StyledButton = styled(Button)`
  :disabled {
    cursor: not-allowed;
  }
`
